import {Injectable, TemplateRef} from '@angular/core';
import {BsModalRef, BsModalService, ModalOptions} from 'ngx-bootstrap/modal';

/**
 * Wraps opening/closing a single ngx-bootstrap template modal so the ref
 * handling and default options live in one place instead of being copied
 * into every host component.
 */
@Injectable()
export class TemplateModalService {
  private modalRef?: BsModalRef;

  public constructor(private readonly bsModalService: BsModalService) {}

  public open(template: TemplateRef<unknown>, options: ModalOptions = {class: 'modal-lg'}): void {
    this.modalRef = this.bsModalService.show(template, options);
  }

  public close(): void {
    this.modalRef?.hide();
  }
}
